import { dashboardT } from '../../../../../lib/messages';
import type { MadBuyCreative } from '../../lineItemsModel';

export function resolveSelectedCreative({
  associationCreative,
  availableCreatives,
  creativeId,
}: {
  associationCreative?: MadBuyCreative | undefined;
  availableCreatives: MadBuyCreative[];
  creativeId: string;
}) {
  if (creativeId === 'none') return undefined;
  return (
    availableCreatives.find((creative) => creative.id === creativeId) ??
    (!creativeId ? associationCreative : undefined)
  );
}

export function resolveCreativeSelectHelperMessage({
  availableCount,
  brandSelected,
  error,
  loading,
}: {
  availableCount: number;
  brandSelected: boolean;
  error: boolean;
  loading: boolean;
}) {
  if (!brandSelected) {
    return dashboardT('madBuy.lineItems.selectBrandBeforeCreativeAssociations');
  }
  if (error) {
    return dashboardT('madBuy.lineItems.refreshOrTryAgain');
  }
  if (!loading && availableCount === 0) {
    return dashboardT('madBuy.lineItems.noCreativesForBrandAndType');
  }
  return undefined;
}
